import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

// Send token in a custom header. The ingress forces
// "Access-Control-Allow-Headers: *", which covers custom headers but NOT
// the reserved "Authorization" header — so we avoid Authorization entirely.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("uc_token");
  if (token) config.headers["X-Auth-Token"] = token;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
